// File to be deleted when updgrade to Vuex4
import { getCurrentInstance } from 'vue';

const useStore = () => {
  const vm = getCurrentInstance();
  if (!vm) throw new Error('must be called in setup');
  return vm.proxy.$store;
};

export default useStore;
